export const adaptClearEcommerce = () => {
  return {
    ecommerce: null,
  }
}
